import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { AuthProvider } from 'context/AuthContext';
import { ToastContainer } from 'react-toastify';
// La hoja de estilos de react-toastify no estaba importada: los avisos se
// renderizaban como divs sin estilo en una esquina.
import 'react-toastify/dist/ReactToastify.css';

import App from "./App";
import { initTheme } from "utils/theme";

//NUEVO: importar YearProvider
import { YearProvider } from "context/YearContext";

// Sincroniza el tema persistido antes del primer render.
initTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      {/* NUEVO: envolver App con YearProvider */}
      <YearProvider>
        <App />
      </YearProvider>

      <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover={false}
        draggable
        pauseOnFocusLoss
      />
    </AuthProvider>
  </BrowserRouter>
);
